import React, { useEffect } from "react";

import { useParams, useSearchParams } from "react-router-dom";
import { Grid, Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

import {
  getLobbyBannersStart,
  setReferralCode
} from "../../redux-saga/redux/casino/lobby/casinoLobby";
import {
  handleOpenSignUpRedux,
  setAgentId
} from "../../redux-saga/redux/auth/authentication";
// import CategoryGames from "../../container/Casino/Lobby/CategoryGames";
import { resetIsGameStarted } from "../../redux-saga/redux/casino/lobby/casinoGames";
import Session from "../../utils/session";
import TopGames from "../Casino/Lobby/TopGames";
import useStyles from "./Home.styles";
// import CasinoRegistrationUI from "../../HOC/modal/DepositReminderModal/RegisterBonusCard";
import SearchGames from "../Casino/Lobby/SearchGames";
// import CasinoDepositUI from "../../HOC/modal/DepositReminderModal/AfterRegisterBonus";
import CasinoDepositUI from "../../HOC/modal/DepositReminderModal/AfterRegisterBonusFifa";
// import GamesCardUI from "../../HOC/modal/DepositReminderModal/GamesCard";
import InfoCardHome from "../../HOC/modal/InfoCardHome/InfoCardHome";
// import ForgotPasswordModal from "../../components/Header/Login/ForgotPasswordModal";
// import SportsCarousel from "../../HOC/modal/SportsCard/SportsCard";
import SportsCarousel from "../../HOC/modal/SportsCard/SportsCard";
import { getSportsBannerStart } from "../../redux-saga/redux/sportsBanner";

const mainBannerSelector = createSelector(
  (state) => state.casinoLobby.lobbyBannerList,
  (list) => list?.["0"]?.[0]?.["banners"] || []
);

const HomePageInner = () => {
  const classes = useStyles();
  //   const { t } = useTranslation();
  const dispatch = useDispatch();
  // const location = useLocation();
  const { referralCode } = useParams();
  // const query = new URLSearchParams(location.search);
  // const userId = query.get("id");
  // const token = query.get("token");

  // console.log("token=========", token)
  // const [openTempModal, setOpenTempModal] = React.useState(false);
  const [searchParams] = useSearchParams();
  const agentID = searchParams.get("agentUser");
  //   const [isMobile, setIsMobile] = useState(false);
  const { isLoggedIn, userId } = useSelector((state) => state.authentication);

  // console.log(userId,"userid")
  // Selectors for homeLobby (sub banners)
  // const subBannerLoadingSelector = createSelector(
  //   (state) => state.homeLobby.bannerloading,
  //   (bannerloading) => bannerloading?.[1]
  // );

  const lobbyBannerList = useSelector(mainBannerSelector);
  const { loading: bannerLoading } = useSelector((state) => state.casinoLobby);
  // ✅ Device detection

  // useEffect(() => {
  //   if(token) setOpenTempModal(true)
  // }, [token])

  // ✅ Referral & Agent logic
  useEffect(() => {
    if (referralCode) {
      dispatch(setReferralCode(referralCode));
    }
    if (!Session?.getSessionCred && agentID) {
      dispatch(setAgentId(agentID));
      dispatch(handleOpenSignUpRedux());
    }
    dispatch(resetIsGameStarted());
  }, [dispatch, referralCode, agentID]);

  useEffect(() => {
    if (!lobbyBannerList?.length) {
      const payload = { pageType: 9 };

      // 🔹 If user is logged in, include their userId
      if (isLoggedIn && userId) {
        const numericUserId = Number(userId);
        if (!isNaN(numericUserId)) {
          payload.userId = numericUserId;
        }
      }

      dispatch(getLobbyBannersStart(payload));
    }
  }, [dispatch, lobbyBannerList?.length, isLoggedIn, userId]);

  useEffect(() => {
    dispatch(getSportsBannerStart());
  }, [dispatch]);
  const { data: sportsData, loading: sportsLoading } = useSelector(
    (state) => state.sportsBanner
  );

  return (
    <>
      {/* <ForgotPasswordModal 
      open={openTempModal}
      onClose={() => setOpenTempModal(false)}
    /> */}
      <Grid className={classes.homeWrap}>
        {bannerLoading ? (
          // Skeleton Loader UI
          <div className="flex flex-col min-[830px]:flex-row items-stretch justify-center gap-4 pb-4">
            {/* Left Skeleton Card */}
            <div className="w-full min-[830px]:w-1/2 flex md:mt-0">
              <div className="relative w-full bg-[#0A2024] rounded-3xl p-4 pb-0 min-h-[280px]">
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={200}
                  sx={{ bgcolor: "#12494E", borderRadius: "12px" }}
                />
                <Skeleton
                  variant="text"
                  width="80%"
                  height={30}
                  sx={{ bgcolor: "#12494E", mt: 2 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={35}
                  sx={{ bgcolor: "#12494E", mt: 2, borderRadius: "6px" }}
                />
              </div>
            </div>
            {/* Right Skeleton Cards Grid */}
            <div className="w-full min-[830px]:w-1/2 grid grid-cols-2 sm:grid-cols-2 gap-3">
              <Skeleton
                variant="rectangular"
                width="100%"
                height={250}
                sx={{ bgcolor: "#12494E", borderRadius: "24px" }}
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={250}
                sx={{ bgcolor: "#12494E", borderRadius: "24px" }}
              />
            </div>
          </div>
        ) : (
          // Actual Content
          <>
            {/* {!isLoggedIn && <CasinoRegistrationUI />} */}
            {isLoggedIn && <CasinoDepositUI />}
            {/* {isLoggedIn && <GamesCardUI />} */}
          </>
        )}
        <SearchGames />
        <Grid className={classes.slotgameContainer}>
          <TopGames subCategoryType="slotGame" />
          {/* <CategoryGames
            subCategoryType="slotGame"
            notShowNoGameMsg={true}
            isHome={true}
          /> */}
        </Grid>
        {!sportsLoading && sportsData?.data && sportsData.data.length > 0 && (
          <SportsCarousel />
        )}
        <InfoCardHome />
      </Grid>

      <div className={classes.footerDiv}></div>
    </>
  );
};

export default HomePageInner;
